/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { findKey } from 'lodash';
import { Menu as AntdMenu } from 'antd';
import { createFromIconfontCN } from '@ant-design/icons';
import Actions from '@/actions';

const MenuIcon = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_2798821_uy0kz0nkopr.js"
});

const Menu = ({ menuList, menuObj }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  // 当前展开的 SubMenu 菜单项 key 数组
  const [openKeys, setOpenKeys] = useState([]);
  // 当前选中的菜单项 key 数组
  const [selectedKeys, setSelectedKeys] = useState([]);

  /**
   * 创建菜单元素
   * @param {Array} menus 菜单列表
   */
  const getMenuItems = (menus) => {
    const ele = menus.map(({ id, menuName, menuLink, menuIcon, isVisible, subMenuList }) => {
      // 判断是否还有子菜单
      let hasSubMenu = false;
      if (subMenuList && subMenuList.length) {
        for (let i = 0; i < subMenuList.length; i += 1) {
          const { isVisible } = subMenuList[i];
          if (isVisible) {
            hasSubMenu = true;
            break;
          }
        }
      }
      if (hasSubMenu) {
        return isVisible ? {
          key: id,
          label: menuName,
          icon: menuIcon ? <MenuIcon className="menu-icon" type={menuIcon} /> : null,
          children: getMenuItems(subMenuList)
        } : null;
      }
      return isVisible ? {
        key: id,
        label: menuLink ? <Link to={menuLink}>{menuName}</Link> : menuName,
        icon: menuIcon ? <MenuIcon className="menu-icon" type={menuIcon} /> : null
      } : null;
    });
    return ele;
  }

  /**
   * 调接口 - 获取菜单列表
   */
  const initMenuData = async () => {
    console.log('调接口-获取菜单')
    const action = await Actions.getMenuList();
    dispatch(action);
  }

  /**
   * 根据地址栏信息找到需要展开的菜单
   */
  const findSelectedMenus = () => {
    const newOpenKeys = [];
    const activeKey = findKey(menuObj, ({ menuLink }) => {
      return menuLink === location.pathname;
    });
    const findOpenKey = ({ id, parentId = null }) => {
      if (`${id}` !== activeKey) {
        newOpenKeys.push(`${id}`);
      }
      if (parentId) {
        findOpenKey(menuObj[parentId]);
      }
    }
    if (activeKey) {
      findOpenKey(menuObj[activeKey]);
      setSelectedKeys([activeKey]);
      setOpenKeys(openKeys.concat(newOpenKeys));
    } else {
      setSelectedKeys([]);
    }
  }

  useEffect(() => {
    initMenuData();
  }, []);

  // 地址栏更新时 更新展开的菜单
  useEffect(() => {
    findSelectedMenus();
  }, [menuList, location.pathname]);

  return (
    <AntdMenu
      className="cts-menu"
      theme="dark"
      mode="inline"
      openKeys={openKeys}
      items={getMenuItems(menuList)}
      selectedKeys={selectedKeys}
      onOpenChange={(openKeys) => { setOpenKeys(openKeys); }}
      onSelect={({ id }) => { setSelectedKeys(id); }}
    />
  );
}

const store = (state) => {
  const { menu } = state;
  return menu;
}

export default connect(store)(Menu);